<template>
    <div class="cruisemap">
        <button v-if="isOffice" v-on:click="updateRoute">
            Reload route from api
        </button>
        <div ref="map" id="center-map" class="width100" style="height:350px;" />
    </div>
</template>

<script>
/* global H */
export default {
    name: 'CruiseMap',
    data: function() {
        return {
            appId: 'WNeJhJdsX9Xp2kp217iQ',
            appCode: '1a5erGXfCeM80MrhJGzWRQ',
            useHTTPS: true,
            useCIT: true,
            platform: {},
            behavior: null,
            ui: null,
            first: true,
            second: true,
            def: null,
            typeArr: [],
        }
    },
    props: {
        itinerary: Object,
    },
    created() {
        this.platform = new H.service.Platform({
            app_id: this.appId,
            app_code: this.appCode,
            useHTTPS: this.useHTTPS,
            useCIT: this.useCIT,
        })
    },
    mounted() {
        let pixelRatio = window.devicePixelRatio || 1
        let defaultLayers = this.platform.createDefaultLayers({
            tileSize: pixelRatio === 1 ? 256 : 512,
            ppi: pixelRatio === 1 ? undefined : 320,
        })

        this.map = new H.Map(this.$refs.map, defaultLayers.normal.map, {
            center: { lat: 52, lng: 5 },
            zoom: 5,
            pixelRatio: pixelRatio,
        })

        this.map.setBaseLayer(defaultLayers.terrain.xbase)

        // this.map.addEventListener('mapviewchangeend', function() {
        //     var zoom = this.map
        // })

        this.behavior = new H.mapevents.Behavior(
            new H.mapevents.MapEvents(this.map)
        )

        this.ui = H.ui.UI.createDefault(this.map, defaultLayers)

        this.addPolylineToMap()
    },
    computed: {
        dayCount: function() {
            return Object.keys(this.itinerary.days).length
        },
        isOffice: function() {
            return this.$store.state.isKantoorIP
        },
        lastDay: function() {
            return this.itinerary.days[this.dayCount]
        },
        cleanDayArray: function() {
            let retObj = {}
            let dayInd = 0
            for (dayInd in this.itinerary.days) {
                let day = this.itinerary.days[dayInd]
                if (this.hasCoords(day)) {
                    day.day = dayInd
                    if (typeof retObj[' ' + day.id] === 'undefined') {
                        retObj[' ' + day.id] = []
                    }
                    retObj[' ' + day.id].push(dayInd)
                }
            }
            return retObj
        },
    },
    methods: {
        updateRoute: function() {
            if (
                confirm(
                    'Weet je zeker dat je de HELE map-route wilt verwijderen?, ' +
                        'niet voor cruisespecialisten :-)'
                )
            ) {
                this.$store.dispatch('deleteRoutes', {
                    routes: this.cleanDayArray,
                })
            }
        },
        changeFeatureStyle: function(zoom) {
            if (this.first) {
                this.first = false
                return
            }

            if (this.second) {
                this.second = false
                this.def = zoom
            }

            //No other way to append to created map in a vue-like style
            //so document is used to alter map text
            if (zoom < this.def) {
                this.typeArr.map(type => {
                    if (document.getElementById(type))
                        document.getElementById(type).innerText = ''
                })
            } else {
                this.typeArr.map(type => {
                    if (document.getElementById(type))
                        document.getElementById(type).innerText = type
                })
            }
        },
        hasCoords: function(day) {
            return day['route'] !== '' && day['route'] !== undefined
        },
        addPolylineToMap: function() {
            let group = new H.map.Group()
            let cleanInd = 0

            for (cleanInd in this.cleanDayArray) {
                let itemInd = 0
                let typeString = ''
                let port = {}

                for (itemInd in this.cleanDayArray[cleanInd]) {
                    let portDayInd = this.cleanDayArray[cleanInd][itemInd]
                    port = this.itinerary.days[portDayInd]

                    typeString += portDayInd + '-' + port.haven_naam
                    let doublePort = typeString.replace(/[^0-9]/g, '')
                    if (doublePort.length > 1) {
                        typeString =
                            doublePort.slice(0, 1) +
                            '/' +
                            doublePort.slice(1, 2) +
                            '-' +
                            port.haven_naam
                    }

                    // this.typeArr.push(typeString)
                    if (port['route']) {
                        let geoPoint = H.util.wkt.toGeometry(port['route'])
                        group.addObject(
                            new H.map.Polyline(geoPoint, {
                                style: { lineWidth: 2.75 },
                                arrows: {
                                    fillColor: '#3E85CC',
                                    frequency: 7,
                                    width: 3,
                                    length: 3,
                                },
                            })
                        )
                    }
                }
                let outerElement = document.createElement('div'),
                    innerElement = document.createElement('div'),
                    extraElement = document.createElement('div')

                extraElement.style.color = 'black'
                extraElement.style.font = 'bold 11px  Times New Roman'
                extraElement.innerHTML =
                    '<div id="' +
                    typeString +
                    '" style="margin-top: 2px; color: black;">' +
                    typeString +
                    '</div>'

                innerElement.innerHTML =
                    '<span style="margin-left: -5px; margin-top: -5px; height: 10px; width: 10px; background-color: #3E85CC; border-radius: 50%; display: block;"></span>'

                innerElement.appendChild(extraElement)
                outerElement.appendChild(innerElement)

                let domIcon = new H.map.DomIcon(outerElement)

                let marker = new H.map.DomMarker(
                    {
                        lat: port['lat'],
                        lng: port['lng'],
                    },
                    {
                        icon: domIcon,
                    }
                )
                group.addObject(marker)
            }

            this.map.addObject(group)
            this.map.setViewBounds(group.getBounds())
        },
    },
}
</script>
<style>
#center-map {
    max-width: 100% !important;
    width: 350px;
    float: left;
}

.H_ui {
    display: none !important;
}
</style>
